import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ProductBundleList = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const schoolId = localStorage.getItem("school_id");

  const [filters, setFilters] = useState({
    q: "",
    category_id: "",
    subcategory_id: "",
    page: 1,
    per_page: 20,
  });

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);

  const listURL = `https://dgps.co.in/api/product/bundle/list`;
  const categoryURL = `https://dgps.co.in/api/product/category/list?school_id=${schoolId}`;
  const subcategoryURL = `https://dgps.co.in/api/product/subcategory/list`;

  // Load categories
  useEffect(() => {
    fetch(categoryURL)
      .then((r) => r.json())
      .then((d) => setCategories(d || []))
      .catch(() => {});
  }, [categoryURL]);

  // Load subcategories when category changes
  useEffect(() => {
    if (!filters.category_id) {
      setSubcategories([]);
      setFilters((f) => ({ ...f, subcategory_id: "" }));
      return;
    }
    fetch(`${subcategoryURL}?category_id=${filters.category_id}`)
      .then((r) => r.json())
      .then((d) => setSubcategories(d || []))
      .catch(() => {});
  }, [filters.category_id, subcategoryURL]);

  const fetchList = async () => {
    const params = new URLSearchParams({
      school_id: schoolId,
      q: filters.q || "",
      category_id: filters.category_id || "",
      subcategory_id: filters.subcategory_id || "",
      page: String(filters.page),
      per_page: String(filters.per_page),
    });
    const res = await fetch(`${listURL}?${params.toString()}`);
    const data = await res.json();
    if (data.status === "success") {
      setRows(data.data || []);
      setTotal(data.total || 0);
    }
  };

  useEffect(() => {
    if (!schoolId) return;
    fetchList();
    // eslint-disable-next-line
  }, [schoolId, filters.page, filters.per_page]);

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value, page: 1 });
  };

  const totalPages = Math.max(1, Math.ceil(total / filters.per_page));

  return (
    <div style={{ display: "flex", minHeight: "100vh", backgroundColor: "#f4f6f8" }}>
      <div style={{ flex: 1 }}>
        <main style={{ padding: 30, maxWidth: 1100, margin: "0px auto" }}>
          {/* Filters */}
          <section style={cardStyle}>
            <h2 style={titleStyle}>📦 Product Catalog</h2>
            <div style={grid4}>
              <input
                name="q"
                placeholder="Search (product/variant/category/subcategory)"
                value={filters.q}
                onChange={handleFilterChange}
                style={inputStyle}
              />
              <select
                name="category_id"
                value={filters.category_id}
                onChange={handleFilterChange}
                style={inputStyle}
              >
                <option value="">All Categories</option>
                {categories.map((c) => (
                  <option key={c.id} value={c.id}>{c.category_name}</option>
                ))}
              </select>
              <select
                name="subcategory_id"
                value={filters.subcategory_id}
                onChange={handleFilterChange}
                style={inputStyle}
                disabled={!filters.category_id}
              >
                <option value="">All Subcategories</option>
                {subcategories.map((s) => (
                  <option key={s.id} value={s.id}>{s.subcategory_name}</option>
                ))}
              </select>
              <button onClick={fetchList} style={buttonStyle}>Filter</button>
            </div>
          </section>

          {/* List */}
          {rows.map((p) => (
            <section key={p.product_id} style={cardStyle}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <h3 style={{ margin: 0, color: "#0f172a" }}>{p.product_name}</h3>
                  <div style={{ color: "#475569", fontSize: 14 }}>
                    {p.category_name} › {p.subcategory_name} &nbsp;•&nbsp; Type: {p.product_type}
                  </div>
                </div>
                <Link to={`/admin/product-bundle/view/${p.product_id}`} style={btnGhost}>View</Link>
              </div>

              {p.variants?.length ? (
                <div style={{ marginTop: 14, overflowX: "auto" }}>
                  <table className="min-w-full" style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#f1f5f9", color: "#334155" }}>
                        <th style={th}>Variant</th>
                        <th style={th}>Class/Size/Range</th>
                        <th style={th}>Cost</th>
                        <th style={th}>Sale</th>
                        <th style={th}>Stock</th>
                      </tr>
                    </thead>
                    <tbody>
                      {p.variants.map((v, i) => (
                        <tr key={v.variant_id} style={{ background: i % 2 ? "#fff" : "#f8fafc" }}>
                          <td style={td}>{v.variant_name}</td>
                          <td style={td}>
                            {v.class_id ? `Class: ${v.class_id}` : ""}
                            {v.size ? `Size: ${v.size}` : ""}
                            {v.height_range || v.weight_range ? ` ${v.height_range || ""} ${v.weight_range || ""}` : ""}
                          </td>
                          <td style={td}>₹{v.cost_price}</td>
                          <td style={td}>₹{v.sale_price}</td>
                          <td style={td}>{v.stock_qty}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div style={{ marginTop: 8, color: "#64748b" }}>No variants yet.</div>
              )}
            </section>
          ))}

          {/* Pagination */}
          <div style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 16 }}>
            <button
              onClick={() => setFilters((f) => ({ ...f, page: Math.max(1, f.page - 1) }))}
              style={btnGhost}
              disabled={filters.page <= 1}
            >
              Prev
            </button>
            <div style={{ padding: "8px 12px" }}>
              Page {filters.page} of {totalPages}
            </div>
            <button
              onClick={() => setFilters((f) => ({ ...f, page: Math.min(totalPages, f.page + 1) }))}
              style={btnGhost}
              disabled={filters.page >= totalPages}
            >
              Next
            </button>
          </div>
        </main>
      </div>
    </div>
  );
};

const grid4 = { display: "grid", gridTemplateColumns: "2fr 1fr 1fr auto", gap: 12 };
const inputStyle = { width: "95%", padding: 10, borderRadius: 8, border: "1px solid #cbd5e1", background: "#fff" };
const cardStyle = { background: "#ffffff", padding: 20, borderRadius: 12, boxShadow: "0 2px 10px rgba(0,0,0,.05)", marginBottom: 16 };
const titleStyle = { color: "#0f172a", marginBottom: 10, fontWeight: 700, fontSize: 20 };
const th = { textAlign: "left", padding: 10, fontWeight: 600, borderBottom: "1px solid #e2e8f0" };
const td = { padding: 10, borderBottom: "1px solid #f1f5f9", color: "#0f172a",textAlign:"left" };
const buttonStyle = { padding: "10px 16px", background: "#0ea5e9", color: "#fff", borderRadius: 8, border: "none", cursor: "pointer" };
const btnGhost = { padding: "8px 14px", background: "#e2e8f0", color: "#0f172a", borderRadius: 8, textDecoration: "none" };

export default ProductBundleList;
